import { routeItem } from '@/types';
import { lazy } from 'react';

const HomePage = lazy(() => import('./pages'));

export const homeRoutes: routeItem[] = [
  {
    index: true,
    element: <HomePage />,
  },
];